// import React from "react";
// import Chart from "react-apexcharts";

// const PieChartComponent = () => {
//   const chartOptions = {
//     labels: ["Course 1", "Course 2", "Course 3", "Course 4"],
//     legend: {
//       position: 'bottom',
//     },
//     responsive: [{
//       breakpoint: 480,
//       options: {
//         chart: {
//           width: 300
//         },
//         legend: {
//           position: 'bottom'
//         }
//       }
//     }]
//   };

//   const chartSeries = [44, 33, 54, 12]; // Data in percent or values

//   return (
//     <div>
//       <h3>Course Distribution</h3>
//       <Chart
//         options={chartOptions}
//         series={chartSeries}
//         type="pie"
//         width="100%"
//         height="400"
//       />
//     </div>
//   );
// };

// export default PieChartComponent;

import React, { useEffect } from "react";
import Chart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import { fetchDashboardUsers } from "../../redux/reducer/dashboardSlice";

const PieChartComponent = ({data}) => {

  const {dashboardUserData, dashboardUserLoading} = useSelector((prev) => prev.dashboard)
  const dispatch = useDispatch();
  
  useEffect(()=>{
    dispatch(fetchDashboardUsers())
  },[dispatch])

  const totalUsers = dashboardUserData?.total_user || 0;
  const androidUsers = dashboardUserData?.android_user || 0;
  const iosUsers = dashboardUserData?.ios_user || 0;
  const otherUsers = totalUsers - (androidUsers + iosUsers);

  const options = {
    chart: {
      type: "donut",
    },
    labels: ["Total", "Android Users", "iOS Users"],
    legend: {
      position: "bottom",
    },
    colors: ["#44ad51", "#008FFB", "#FEB019"],
    
    dataLabels: {
      enabled: true,
      style: {
        fontSize: '16px', // Data label font size
        fontWeight: 'bold',
      },
      formatter: function (val, opts) {
        // return `${Math.abs(val/10)}`;
        return opts.w.config.series[opts.seriesIndex];
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + " users";
        },
      },
    },
  };

  const series = [totalUsers, androidUsers, iosUsers];

  return (
    <div style={{ height: "415px" }}>
      <Chart
        options={options}
        series={series}
        type="donut"
        width="100%"
        height={350}
      />
    </div>
  );
};

export default PieChartComponent;

// const PieChartComponent = () => {
//   const { dashboardUserData, dashboardUserLoading } = useSelector((prev) => prev.dashboard);
//   const dispatch = useDispatch();

//   useEffect(() => {
//     dispatch(fetchDashboardUsers());
//   }, [dispatch]);

//   const totalUsers = dashboardUserData?.total_user || 0;
//   const androidUsers = dashboardUserData?.android_user || 0;
//   const iosUsers = dashboardUserData?.ios_user || 0;
//   const otherUsers = totalUsers - (androidUsers + iosUsers);

//   const options = {
//     chart: {
//       type: "donut",
//     },
//     labels: ["Android Users", "iOS Users", "Total Users"],
//     legend: {
//       position: "bottom",
//     },
//     colors: ["#00E396", "#008FFB", "#FEB019"],
//     dataLabels: {
//       enabled: true,
//       formatter: function (val) {
//         return `${val.toFixed(1)}%`;
//       },
//     },
//     tooltip: {
//       y: {
//         formatter: function (val) {
//           return val + " users";
//         },
//       },
//     },
//   };

//   const series = [androidUsers, iosUsers, totalUsers];

//   if (dashboardUserLoading) return <div>Loading chart...</div>;
//   if (!totalUsers) return <div>No user data found</div>;

//   return (
//     <div style={{ height: "415px" }}>
//       <Chart options={options} series={series} type="donut" width="100%" height={350} />
//     </div>
//   );
// };


// export default PieChartComponent;

